import { Button, Stack, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useLeaveProjectMutation } from '../../api/projects'
import modalEmitter from '../ModalComponent/modalEmitter'

type Props = {
  projectId: number
}

export function LeaveProjectModalBody({ projectId }: Props) {
  const [leaveProject, leaveState] = useLeaveProjectMutation()
  const [message, setMessage] = useState('')

  const handleConfirm = async () => {
    if (leaveState.isLoading) return
    try {
      const trimmed = message.trim()
      await leaveProject({ projectId, ...(trimmed.length > 0 ? { message: trimmed } : {}) }).unwrap()
      toast.success('Вы вышли из проекта')
      modalEmitter.emitCloseModal()
    } catch {
      toast.error('Не удалось выйти из проекта')
    }
  }

  return (
    <Stack gap={2}>
      <Typography>Вы уверены, что хотите выйти из проекта?</Typography>
      <Typography variant="black-14-light">Сообщение (необязательно)</Typography>
      <TextField
        placeholder="Напишите причину или комментарий"
        multiline
        minRows={4}
        value={message}
        onChange={(e) => setMessage(e.target.value.slice(0, 500))}
        helperText={`${message.length}/500`}
        disabled={leaveState.isLoading}
        fullWidth
      />
      <Stack direction="row" gap={2} justifyContent="flex-end">
        <Button variant="follow" disabled={leaveState.isLoading} onClick={() => modalEmitter.emitCloseModal()}>
          Отмена
        </Button>
        <Button variant="danger" disabled={leaveState.isLoading} onClick={() => void handleConfirm()}>
          Подтвердить
        </Button>
      </Stack>
    </Stack>
  )
}

export function openLeaveProjectModal(projectId: number) {
  modalEmitter.emitOpenModal({
    dialog: {
      title: 'Выйти из проекта',
      body: <LeaveProjectModalBody projectId={projectId} />,
      modalToCentrPosition: true,
    },
  })
}
